export const truncateTimestampToSeconds = (timestamp: string) =>
  Math.floor(new Date(timestamp).getTime() / 1000);
